import { render, staticRenderFns } from "./DeliveryReturn.vue?vue&type=template&id=35325ab8&scoped=true&"
import script from "./DeliveryReturn.vue?vue&type=script&lang=js&"
export * from "./DeliveryReturn.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryReturn.vue?vue&type=style&index=0&id=35325ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35325ab8",
  null
  
)

export default component.exports